var CurrentUser = require("lib/account/CurrentUser");
var OnboardingModal = require("components/users/teachers/onboarding/OnboardingModal");
var OnboardingChecklist = require("components/users/teachers/onboarding/OnboardingChecklist");
var TrialStatusDisplay = require("components/users/teachers/upgrade/TrialStatusDisplay");
var OverdrawnAccountNotice = require("components/users/teachers/upgrade/OverdrawnAccountNotice");

var WidgetContainer = require("components/data/widgets/WidgetContainer.js")
var WidgetConfig = require('lib/widgets/WidgetsConfig')

require("users/teachers/custom_teacher_home_page");

class CustomTeacherHomePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		LuckyOrangeClient.tagComponent("CustomTeacherHomePage");
		this.state = {
			admin: null,
			showOnboardingModal: false, skipOnboarding: false
		};
	}

	onViewChange(view) {
		this.setState({ currentView: view });
	}

	render() {
		if (this.state.showOnboardingModal) {		
			var track = "quiz-customization";
			var onboardingModal = (
				<OnboardingModal track={ track } />
			);
		}

		var currentUser = CurrentUser.get();

		var activeTrials  = currentUser.account.active_trials;
		var expiredTrials = currentUser.account.expired_trials
		var allTrials = _.extend({}, activeTrials, expiredTrials);

		if (currentUser && currentUser.account && _.any(allTrials)) {
			var trialDisplay = (
				<TrialStatusDisplay trials={ allTrials } />
			);
		} 

		if (this.state.admin) {
			if (this.state.admin.account_overdrawn) {
				var overdrawnDisplay = (
					<OverdrawnAccountNotice source="dashboard" />
				);
			}
		}

		var onboardingChecklist = <OnboardingChecklist />;

		var widgetParams = { topLevelDigest: WidgetConfig.TEACHER_ENTITY_TYPE, period: WidgetConfig.PERIOD, adminID: [currentUser.id] }
		var widgetContainer = <WidgetContainer userID={currentUser.id} widgetParams={widgetParams} />

		return (
			<div className="container" id="teacherHomePage">
				{ onboardingChecklist }
				<header className="pageHeader hideOnPrint">
					<h1> Teacher Dashboard </h1>
				</header>
				{ overdrawnDisplay }
				{ trialDisplay }
				{ widgetContainer }
				{ onboardingModal }
			</div>
		)
	}

	componentDidMount() {
		this.fetchAdminData();
		$(window.document).on("expectations-updated", this.onExectationsUpdate);
	}

	componentWillUnmount() {
		$(window.document).off("expectations-updated", this.onExectationsUpdate);
	}

	onExectationsUpdate() {
		this.setState({ admin: null }, this.fetchAdminData); 
	}

	fetchAdminData() {
		var embeds = "admin.account_overdrawn";
		CurrentUser.api().getAdmin(this.props.match.params.id, { embed: embeds }, $wr.apiHandler((response) => {
			var pendingOnboarding = (response.admin.role == "teacherRole") && response.admin.pending_onboarding;

			this.setState({ admin: response.admin, showOnboardingModal: pendingOnboarding } );
		}));
	}
}

CustomTeacherHomePage.propTypes = PageStrictPropTypes({
	userIDs: PropTypes.array
});

CustomTeacherHomePage.SCHOOL_YEAR = 'School Year';
CustomTeacherHomePage.LAST_WEEK = 'Last 7 Days';
CustomTeacherHomePage.LAST_MONTH = 'Last 30 Days';
CustomTeacherHomePage.CUSTOM_DATES = 'Custom Dates';

module.exports = CustomTeacherHomePage;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/CustomTeacherHomePage.js